(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-gallery')) {
    customElements.define('testimonial-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.track = this.querySelector('[data-gallery-track]');
        this.cards = Array.from(this.querySelectorAll('[data-gallery-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = null;
        this.drag = null;
        this.suppressClick = false;
        this.clickReset = null;
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = window.requestAnimationFrame(() => {
            this.frame = null;
            this.updateCurrent();
          });
        };
        this.onResize = () => this.refresh();
        this.onBlockSelect = event => {
          const card = event.target.closest('[data-gallery-card]');
          const index = this.cards.indexOf(card);
          if (index >= 0) this.goTo(index);
        };
        this.onTouchStart = event => {
          if (event.touches.length !== 1) return;
          const touch = event.touches[0];
          this.startDrag(touch.clientX, touch.clientY);
        };
        this.onTouchMove = event => {
          if (!this.drag || event.touches.length !== 1) return;
          const touch = event.touches[0];
          this.moveDrag(touch.clientX, touch.clientY, event);
        };
        this.onTouchEnd = () => this.finishDrag();
        this.onPointerDown = event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.startDrag(event.clientX, event.clientY, event.pointerId);
        };
        this.onPointerMove = event => {
          if (!this.drag || this.drag.pointerId !== event.pointerId) return;
          this.moveDrag(event.clientX, event.clientY, event);
        };
        this.onPointerEnd = event => {
          if (!this.drag || this.drag.pointerId !== event.pointerId) return;
          this.finishDrag();
        };
        this.onClickCapture = event => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        };
        this.onDragStart = event => {
          if (this.isMobile) event.preventDefault();
        };
        this.viewport?.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport?.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.viewport?.addEventListener('touchmove', this.onTouchMove, { passive: false });
        this.viewport?.addEventListener('touchend', this.onTouchEnd, { passive: true });
        this.viewport?.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
        this.viewport?.addEventListener('pointerdown', this.onPointerDown);
        this.viewport?.addEventListener('pointermove', this.onPointerMove);
        this.viewport?.addEventListener('pointerup', this.onPointerEnd);
        this.viewport?.addEventListener('pointercancel', this.onPointerEnd);
        this.viewport?.addEventListener('click', this.onClickCapture, true);
        this.viewport?.addEventListener('dragstart', this.onDragStart);
        this.viewport?.classList.add('is-drag-ready');
        window.addEventListener('resize', this.onResize, { passive: true });
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.galleryIndex))));
        if ('ResizeObserver' in window && this.viewport) {
          this.resizeObserver = new ResizeObserver(() => this.refresh());
          this.resizeObserver.observe(this.viewport);
        }
        this.refresh();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.onScroll);
        this.viewport?.removeEventListener('touchstart', this.onTouchStart);
        this.viewport?.removeEventListener('touchmove', this.onTouchMove);
        this.viewport?.removeEventListener('touchend', this.onTouchEnd);
        this.viewport?.removeEventListener('touchcancel', this.onTouchEnd);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport?.removeEventListener('pointermove', this.onPointerMove);
        this.viewport?.removeEventListener('pointerup', this.onPointerEnd);
        this.viewport?.removeEventListener('pointercancel', this.onPointerEnd);
        this.viewport?.removeEventListener('click', this.onClickCapture, true);
        this.viewport?.removeEventListener('dragstart', this.onDragStart);
        this.viewport?.classList.remove('is-drag-ready', 'is-dragging');
        window.removeEventListener('resize', this.onResize);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        if (this.frame) window.cancelAnimationFrame(this.frame);
        if (this.clickReset) window.clearTimeout(this.clickReset);
        this.initialized = false;
      }

      startDrag(clientX, clientY, pointerId = null) {
        if (!this.isMobile || !this.viewport) return;
        this.drag = {
          clientX,
          clientY,
          pointerId,
          scrollLeft: this.viewport.scrollLeft,
          horizontal: false
        };
      }

      moveDrag(clientX, clientY, event) {
        if (!this.drag || !this.viewport) return;
        const deltaX = clientX - this.drag.clientX;
        const deltaY = clientY - this.drag.clientY;
        if (!this.drag.horizontal) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
          if (Math.abs(deltaY) >= Math.abs(deltaX)) {
            this.drag = null;
            return;
          }
          this.drag.horizontal = true;
          this.viewport.classList.add('is-dragging');
          if (this.drag.pointerId !== null && this.viewport.setPointerCapture) {
            try {
              this.viewport.setPointerCapture(this.drag.pointerId);
            } catch (error) {
              // Pointer capture is an enhancement; dragging still works without it.
            }
          }
        }
        event.preventDefault();
        const rtl = window.getComputedStyle(this).direction === 'rtl';
        this.viewport.scrollLeft = this.drag.scrollLeft + deltaX * (rtl ? 1 : -1);
      }

      finishDrag() {
        if (!this.drag || !this.viewport) return;
        const dragged = this.drag.horizontal;
        const pointerId = this.drag.pointerId;
        if (pointerId !== null && this.viewport.hasPointerCapture?.(pointerId)) {
          try {
            this.viewport.releasePointerCapture(pointerId);
          } catch (error) {
            // The pointer may already have been released by the browser.
          }
        }
        this.drag = null;
        this.viewport.classList.remove('is-dragging');
        if (!dragged) return;
        this.suppressClick = true;
        if (this.clickReset) window.clearTimeout(this.clickReset);
        this.clickReset = window.setTimeout(() => {
          this.suppressClick = false;
          this.clickReset = null;
        }, 600);
        const currentIndex = this.getCurrentIndex();
        window.requestAnimationFrame(() => this.goTo(currentIndex));
      }

      refresh() {
        if (!this.viewport || !this.track || this.cards.length === 0) return;
        this.isMobile = window.matchMedia('(max-width: 767.98px)').matches;
        const cardWidth = this.cards[0].getBoundingClientRect().width;
        const edge = this.isMobile ? Math.max(0, (this.viewport.clientWidth - cardWidth) / 2) : 0;
        const edgeValue = `${edge}px`;
        if (this.track.style.getPropertyValue('--testimonial-gallery-edge') !== edgeValue) {
          this.track.style.setProperty('--testimonial-gallery-edge', edgeValue);
        }
        const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.maxIndex = this.isMobile
          ? this.cards.length - 1
          : Math.min(this.cards.length - 1, Math.round(maxScroll / Math.max(1, cardWidth + gap)));
        this.dots.forEach((dot, index) => {
          dot.hidden = index > this.maxIndex;
        });
        this.updateCurrent();
      }

      goTo(index) {
        const targetIndex = Math.min(Math.max(index, 0), this.maxIndex ?? this.cards.length - 1);
        const target = this.cards[targetIndex];
        if (!target || !this.viewport) return;
        const viewportRect = this.viewport.getBoundingClientRect();
        const cardRect = target.getBoundingClientRect();
        const rtl = window.getComputedStyle(this).direction === 'rtl';
        const visualDelta = this.isMobile
          ? cardRect.left + cardRect.width / 2 - (viewportRect.left + viewportRect.width / 2)
          : rtl
            ? cardRect.right - viewportRect.right
            : cardRect.left - viewportRect.left;
        this.viewport.scrollBy({
          left: rtl ? -visualDelta : visualDelta,
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      updateCurrent() {
        if (!this.viewport || this.cards.length === 0) return;
        const currentIndex = this.getCurrentIndex();
        this.dots.forEach((dot, index) => {
          const active = index === currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      getCurrentIndex() {
        if (!this.viewport || this.cards.length === 0) return 0;
        const viewportRect = this.viewport.getBoundingClientRect();
        const rtl = window.getComputedStyle(this).direction === 'rtl';
        let currentIndex = 0;
        let closest = Number.POSITIVE_INFINITY;
        this.cards.forEach((card, index) => {
          if (index > (this.maxIndex ?? this.cards.length - 1)) return;
          const cardRect = card.getBoundingClientRect();
          const distance = this.isMobile
            ? Math.abs(cardRect.left + cardRect.width / 2 - (viewportRect.left + viewportRect.width / 2))
            : Math.abs(rtl ? viewportRect.right - cardRect.right : viewportRect.left - cardRect.left);
          if (distance < closest) {
            closest = distance;
            currentIndex = index;
          }
        });
        return currentIndex;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
